<template>
    <div id="news-detail-page">
        <section class=" section_gap append_gap">
            <!-- <img class="img-fluid" src="../assets/allRooms.svg" alt="img"> -->
            <img class="img-fluid" src="../assets/allRoomsWithPrice.png" alt="img" style="max-width:1024px;">
        </section>
        <section class=" section_gap append_gap">
            <img class="img-fluid" src="../assets/allRoomsWithPriceA.png" alt="img" style="max-width:1024px;">
        </section>
        <section class=" section_gap append_gap">
            <img class="img-fluid" src="../assets/allRoomsWithPriceB.png" alt="img" style="max-width:1024px;">
        </section>
        
    </div>
</template>
<script>

export default {
  name: 'RoomTypeAll',
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
#news-detail-page {
    min-height: 100vh;
    .container {
      position: relative;
    }
    .news-detail {
      margin-top: 20px;
    }
    .news-detail-content {
      border: 1px solid #e6e6e6;
      padding: 100px 60px;
      text-align: left;
      margin-bottom: 100px;
      @media(max-width: 575px){
        padding: 30px 16px;
      }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/RoomTypeAll.vue